// extracted by mini-css-extract-plugin
export default {"packageCard":"packageCard__OGM5Y","preview":"preview__MjNiO","fade":"fade__OTY3Z","moreButtonContainer":"moreButtonContainer__ODE2M","moreButton":"moreButton__ODBiY"};